module.exports = __webpack_public_path__ + "static/media/12.30863a5f.JPG";